import React, { Suspense } from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import Form from './Form'

interface CreateModalProps {
  toggle: (id?: string) => void
  lookupId: string
  isOpen: boolean
}

const CreateModal: React.FC<CreateModalProps> = (props) => {
  const { toggle, lookupId, isOpen } = props
  console.log('CreateModal props:', props)
  return (
    <Modal
      title='Create Lookup Option'
      isOpen={isOpen}
      toggle={() => toggle(undefined)}
    >
      <Header title='Create Lookup Option' />
      <Suspense fallback={<div>Loading...</div>}>
        <Form toggle={toggle} lookupId={lookupId} />
      </Suspense>
    </Modal>
  )
}

export default CreateModal
